// extracted by mini-css-extract-plugin
export default {"nav-links":"NavLinks_nav-links__CYG70","active":"NavLinks_active__3PufZ"};